// mock data for demo purposes
export const posts = [
  {
    id: 'p1',
    title: '欢迎来到我的博客',
    content: '这是一个示例文章。你可以在本地编辑或用后端替换。',
    createdAt: Date.now(),
  },
  {
    id: 'p2',
    title: '第二篇文章',
    content: '更多内容正在建设中…',
    createdAt: Date.now() - 1000 * 60 * 60,
  },
];

export default posts;
